import React from 'react'
import { useSelector } from "react-redux";
import { Collection } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import TheDay from './TheDay';
import { istMitarbeiter } from '../utils';


function addDays(d, days) {
    var result = new Date(d);
    result.setDate(result.getDate() + days);
    return result;
}

function differs(a1, a2) {
    return !(a1.toString() === a2.toString());
}

function getIndex(index, page) { return (index) }; // + (page * 7)); }


const MenueList = (props) => {
    const { user } = useAuthenticator((context) => [context.user]);
    const daten = useSelector(state => state.menueWahl);
    const speiseplan = useSelector(state => state.menues ? (istMitarbeiter(user) ? state.menues.MASPEISEPLAN : state.menues.PATSPEISEPLAN) : []);
    const alleMenues = useSelector(state => state.menues ? state.menues.MENUES : []);

    // console.log('Daten:', daten, Object.keys(daten).length)
    if (!daten || Object.keys(daten).length === 0) return null;
    if (speiseplan.length === 0) return null;
    if (alleMenues.length === 0) return null;

    // console.log('Menueliste:', daten)
    // console.log('MenueList:', alleMenues);
    // console.log('Komponenten:', komponenten);
    // console.log('alleMenues', alleMenues)
    // console.log('Speiseplan', speiseplan)
    const kompListLines = speiseplan ? speiseplan.reduce((prev, curr) => Math.max(curr.KOMPLISTE.split(',').length, prev), 0) : 2;
    // console.log('kompListLines', kompListLines)
    const menuListLines = speiseplan.reduce((prev, curr) => Math.max(curr.MENUELISTE.split(',').reduce((iprev, icurr) =>
        Math.max(alleMenues.filter(item => item.ID === parseInt(icurr))[0] ? alleMenues.filter(item => item.ID === parseInt(icurr))[0].KOMPONENTEN.length - 1 : 0, iprev), 0)
        , prev), 0) + 1;

    const weekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
    const wochennr = [1, 2]; // alleMenues.reduce((wochen, week) => {
    //     return (!(wochen.includes(week['WOCHE']))) ?
    //         wochen.concat(week['WOCHE']) : wochen
    // }, []);
    const allweeks = [];
    const buildDayMenuTuple = (WochenNr, Day, Page) => { return { WochenNr, Day, Page } };
    wochennr.forEach((item, index) => {
        weekdays.forEach((day) => {
            allweeks.push(buildDayMenuTuple(item, day, index));
        })
    });
    // console.log('allweeks:', allweeks)
    const today = props.startDatum ? new Date(props.startDatum) : new Date();
    // console.log(today.toLocaleString(), speiseplan, daten)

    const VonBis = new Date(daten.Fruehstueck[0].DATUM);
    // console.log(VonBis.toLocaleString())

    const isSameDay = (dateObj, dateStr) => {
        const [day, month, year] = dateStr.split('.').map(Number);

        return (
            dateObj.getDate() === day &&
            dateObj.getMonth() + 1 === month &&
            dateObj.getFullYear() === year
        );
    };


    return (
        <Collection
            items={allweeks}
            type="list"
            direction="row"
            gap="var(--amplify-space-small)"
            wrap="wrap"
            justifyContent="left"
        >
            {(item, outer_index) => {
                const dateCopy = addDays(VonBis, outer_index);
                // console.log('outer_index, datum:', outer_index, dateCopy)

                var disabled = !istMitarbeiter(user) && isSameDay(dateCopy, user['attributes']['custom:VON'])
                return dateCopy < today ? null : (
                    <TheDay
                        key={`Day_${outer_index}`}
                        item={item}
                        outer_index={getIndex(outer_index, item.page)}
                        theDay={speiseplan.filter(day => day.TAG === outer_index + 1)[0]}
                        theDate={dateCopy}
                        istMitarbeiter={istMitarbeiter(user)}
                        handleChange={props.onChange}
                        kompListLines={kompListLines}
                        menuListLines={menuListLines}
                        disabled={disabled}
                    />
                )
            }
            }
        </Collection >
    )
}

export {
    differs,
    MenueList,
}

